export const FETCH_CONVERSATION = 'FETCH_CONVERSATION';
export const FETCH_MESSAGE_LIST = 'FETCH_MESSAGE_LIST';
export const FETCH_MORE_MESSAGE = 'FETCH_MORE_MESSAGE';

export const UPDATE_MEDIA_LAYOUT = 'UPDATE_MEDIA_LAYOUT';
export const UPDATE_TO_READ = 'UPDATE_TO_READ';
export const UPDATE_CHAT = 'UPDATE_CHAT';
export const CHANGE_RECIPIENT = 'CHANGE_RECIPIENT';
